import { OrderType } from '@ui/types/trade';
import { getPriceLimit } from '@ui/utils/trade/getPriceLimit';
import BigNumber from 'bignumber.js';
import { useMemo } from 'react';

import { useEntryPrice } from '../components/TradeModule/hooks/useEntryPrice';
import { useIsLong } from '../components/TradeModule/store/useIsLong';
import { useOrderType } from '../components/TradeModule/store/useOrderType';
import { useOpenPositionPairSpreadPercentage } from './useOpenPositionPairSpreadPercentage';

export const useEntryPriceAfterSpread = () => {
  // smart contract is using slippage, but should be spread
  const orderType = useOrderType((s) => s._persistValue);

  const isLong = useIsLong((s) => s._persistValue);
  const entryPrice = useEntryPrice();

  const openPositionPairSpreadPercentage = useOpenPositionPairSpreadPercentage({
    isClosePrice: false,
  });

  // return useMemo(() => {
  return orderType === OrderType.MARKET
    ? entryPrice
      ? getPriceLimit({
          isLong,
          slippageValue: openPositionPairSpreadPercentage,
          price: new BigNumber(entryPrice), // TP/SL use the entry price as base price, do not need user 's slippage impact
        })
      : undefined
    : entryPrice
    ? new BigNumber(entryPrice) // limit order directly use the price , do not have slippage
    : undefined;
  // }, [entryPrice, isLong, orderType, openPositionPairSpreadPercentage]);
};
